var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ColorController, ColorPlugin as BasePlugin } from '@syllepsis/plugin-basic';
import React from 'react';
import ReactDOM from 'react-dom';
import { ColorPicker } from '../../component';
var ReactColorController = /** @class */ (function (_super) {
    __extends(ReactColorController, _super);
    function ReactColorController(editor, store) {
        var _this = _super.call(this, editor, store) || this;
        _this.refactorToolbar();
        return _this;
    }
    ReactColorController.prototype.refactorToolbar = function () {
        var _this = this;
        this.toolbar.handler = function () { };
        this.toolbar.getRef = function (btnDOM) {
            if (!btnDOM)
                return;
            var dom = document.createElement('div');
            var extraDom = (React.createElement(ColorPicker, { mountDOM: btnDOM, name: "color", editor: _this.editor, getValue: _this.getValue, getAttrs: _this.getAttrs, defaultColor: _this.defaultColor }));
            btnDOM.appendChild(dom);
            ReactDOM.render(extraDom, dom);
        };
    };
    return ReactColorController;
}(ColorController));
var ColorPlugin = /** @class */ (function (_super) {
    __extends(ColorPlugin, _super);
    function ColorPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Controller = ReactColorController;
        return _this;
    }
    return ColorPlugin;
}(BasePlugin));
export { ColorPlugin };
//# sourceMappingURL=index.js.map